export const config = {
  base: (import.meta.env.BASE_URL ?? "").replace("/_build", ""),
  resourceBaseURL: "http://localhost:3000",
};
